const { CustomerManagementKYCDocumentsStatusEnum } = require("_constants");

export const getIsKYCDocumentStatusSuccess = (status) => {
  return !![CustomerManagementKYCDocumentsStatusEnum.VerifiedSuccessfully].find(
    (value) => value === status
  );
};

export const getIsKYCDocumentStatusPending = (status) => {
  return !![
    CustomerManagementKYCDocumentsStatusEnum.Submitted,
    CustomerManagementKYCDocumentsStatusEnum.PendingVerification,
    CustomerManagementKYCDocumentsStatusEnum.OngoingVerification,
  ].find((value) => value === status);
};
